import React, { useState, useEffect } from 'react'
import {
  DataProvider,
  NavTabs,
  PosPage,
} from '../../../components-pos'
import { NavLinks } from '../Index-Analysis'
import { FooterBar } from '../../../components-pos/Layout'
import { posDisplaySize } from '../../../settings'
import { ByDate } from './ByDate'
import { ByHour } from './ByHour'


export default function SalesAnalysisIndex(props) {
  return <DataProvider {...props} Component={Index__} />
}

function Index__(props) {
  // useEffect(() => {
  //   document.body.requestFullscreen()
  // }, [])

  const styles = {
    wrap: {
      // border: '1px solid #ddd',
      width: '100%',
      height: posDisplaySize.width * posDisplaySize.ratio,
      backgroundColor: 'azure',
      display: 'flex',
      flexDirection: 'column',
    },
  }

  return (
    <PosPage>
      <div style={styles.wrap}>
        <NavLinks {...props} />
        <NavTabs {...props} size="150px" variant="secondary" >
          {/* <DailyClose {...props} name="일별 매출" /> */}
          <ByDate {...props} name="일별 매출" />
          <ByHour {...props} name="시간대별 매출" />
          <ByMenus {...props} name="메뉴별 매출" />
          <ByStaffs {...props} name="직원별 매출" />
          <CloseBtn {...props} name="종료" variant="danger" />
        </NavTabs>
        <FooterBar {...props} />
      </div>
    </PosPage>
  )
}

// function ByDate(props) {
//   return(
//     <h2>일별 매출현황</h2>
//   )
// }

// function ByTime(props) {
//   return(
//     <h2>시간대별 매출현황</h2>
//   )
// }

function ByMenus(props) {
  return(
    <p>메뉴별 매출현황</p>
  )
}

function ByStaffs(props) {
  return(
    <p>직원별 매출현황</p>
  )
}

function CloseBtn(props) {
  useEffect(()=>{
    props.history.push('/pos')
  }, [])
  return null
}
